import React from 'react';
import { displayValue, getAdministratorCnpj, getAdministratorName, getIntermediaryName, getQuotasText } from './documentHelpers';

export default function PowerOfAttorneyDocument({ acquisition, document }) {
    const name = getIntermediaryName(acquisition);

    return (
        <div className='intermediary-document-paper'>
            <p>
                E, por este público instrumento, nos melhores termos de direito, nomeia e constitui
                sua bastante procuradora a empresa <b><u>OBJETIVA - SOLUÇÕES EM
                    CONSÓRCIO S/S LTDA.</u></b>, inscrita no CNPJ/MF sob nº 13.282.501/0001-50, com
                sede na Rua Espírito Santo, nº 273, bairro Aclimação, São Paulo - SP, CEP:
                01526-020; a quem confere, <u>por tempo indeterminado</u>, os poderes específicos
                para representar a ora OUTORGANTE perante a empresa <b>{displayValue(getAdministratorName(acquisition))}</b>, inscrita no CNPJ/MF sob 
                nº {displayValue(getAdministratorCnpj(acquisition))}, podendo para tanto receber todos e quaisquer valores de
                créditos referente(s) a(s){getQuotasText(acquisition)} calculado pela multiplicação do percentual pago sobre o valor do bem nesta data. Podendo a OUTORGADA,
                ainda, vender, ceder ou transferir a(s) cota(s) para o seu próprio nome ou a quem
                convier. Para tanto, poderá a OUTORGADA assinar todos e quaisquer
                documentos referentes a(s) cota(s) objeto da negociação, em especial Termo(s) de
                Transferência(s) e quitação de valores perante a administradora de consórcio ou
                terceiros. Enfim, praticando, requerendo, alegando e assinando o que preciso for e
                que se faça necessário ao bom e fiel cumprimento do presente mandato, que
                necessite da presença ou da assinatura da (o) ora OUTORGANTE. <b>O
                    PRESENTE MANDATO É LAVRADO EM CARÁTER IRREVOGÁVEL E
                    IRRETRATÁVEL, pois, conferido com cláusula "em causa própria" e com
                    poderes para cumprimento ou confirmação de negócio celebrado entre as
                    partes na forma de <u>CESSÃO DE CRÉDITO DE COTA(S) DE CONSÓRCIO
                        CANCELADA(S)</u>, ficando a
                    OUTORGADA dispensada de prestação de contas, nos termos dos artigos
                    685 e 686, § único, do vigente Código Civil.</b> Diante disso, a Cessionária, ora
                Outorgada, poderá, em nome próprio, em juízo ou fora dele, exercer os atos
                conservatórios dos direitos decorrentes do presente instrumento público de
                procuração.
            </p>
            <p>E, de como assim o disse e me pediu, lavrei-lhe o presente ...............</p>
            <p hidden id='nome_cedente'>{displayValue(name)}</p>
            <p hidden id='documento'>{displayValue(acquisition.doc_type)} {displayValue(document)}</p>
        </div>
    );
}

